import loadable from 'utils/loadable';

export const ChoiceScreen = loadable(
  () =>
    import(
      /* webpackChunkName: "ChoiceScreen" */
      /* webpackPrefetch: true */
      './ChoiceScreen'
    ),
  { isPageLoad: true },
);

export const GetStartScreen = loadable(() =>
  import(
    /* webpackChunkName: "GetStartScreen" */
    /* webpackPrefetch: true */
    './GetStartScreen'
  ),
);

export const PluginSelection = loadable(() =>
  import(
    /* webpackChunkName: "PluginSelection" */
    /* webpackPrefetch: true */
    './PluginSelection'
  ),
);

export const PlatformSelection = loadable(() =>
  import(
    /* webpackChunkName: "PlatformSelection" */
    /* webpackPrefetch: true */
    './PlatformSelection'
  ),
);

export const IntegrationScreen = loadable(() =>
  import(
    /* webpackChunkName: "IntegrationScreen" */
    /* webpackPrefetch: true */
    './IntegrationScreen'
  ),
);

export const CheckoutIntegration = loadable(() =>
  import(
    /* webpackChunkName: "CheckoutIntegration" */
    /* webpackPrefetch: true */
    './CheckoutIntegration'
  ),
);

export const SuccessScreen = loadable(() =>
  import(
    /* webpackChunkName: "CheckoutIntegration" */
    /* webpackPrefetch: true */
    './SuccessScreen'
  ),
);
